export default __webpack_public_path__ + "static/artwavebackground-53e5080f314affd1d91d77b02b9b0c29.png";